import React from "react";

export default function Emoji({ symbol, label, className }) {
  return (
    <span role="img" aria-label={label} className={className}>
      {symbol}
    </span>
  );
}
